import { ToggleButtonProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ToggleButtonProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: <div />, // TODO this prop should be declared as required since the component explodes without it
    } as ToggleButtonProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: <div />,
      labelValue: 'label',
    } as ToggleButtonProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
